import formSteps from '../../shared/helpers/formSteps';

export function addOrderFormStep(stepNumber) {
  return {
    type: 'PUSH_STEP',
    stepName: formSteps[stepNumber],
    stepNumber,
  };
}

export function resetSteps() {
  return {
    type: 'RESET_STEPS',
  };
}
